import React, { JSX } from 'react';

interface State {
  visible: boolean;
  npoId: string;
}

export interface SetVisibleAction {
  type: 'SET_VISIBLE';
  setVisible: boolean;
}

export interface SetNpoId {
  type: 'SET_NPO_ID';
  setNpoId: string;
}

type Action = SetVisibleAction | SetNpoId;

type Dispatch = (action: Action) => void;

interface WikiChangesNpoModalContextData {
  state: State;
  dispatch: Dispatch;
  setVisible: (visible: boolean) => void;
  setNpoId: (npoId: string) => void;
}

const WikiChangesNpoModalContext = React.createContext<WikiChangesNpoModalContextData | undefined>(undefined);

function wikiChangesNpoModalReducer(state: State, action: Action): State {
  switch (action.type) {
    case 'SET_VISIBLE':
      return {
        ...state,
        visible: action.setVisible
      };
    case 'SET_NPO_ID':
      return {
        ...state,
        npoId: action.setNpoId
      };
    default:
      throw new Error(`Unhandled action type`);
  }
}

function WikiChangesNpoModalProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const [state, dispatch] = React.useReducer(wikiChangesNpoModalReducer, {
    visible: false,
    npoId: ''
  });

  const setVisible = (visible: boolean) => {
    dispatch({
      type: 'SET_VISIBLE',
      setVisible: visible
    });
  };

  const setNpoId = (npoId: string) => {
    dispatch({
      type: 'SET_NPO_ID',
      setNpoId: npoId
    });
  };

  return (
    <WikiChangesNpoModalContext.Provider value={{ state, dispatch, setVisible, setNpoId }}>
      {children}
    </WikiChangesNpoModalContext.Provider>
  );
}

function useWikiChangesNpoModal(): WikiChangesNpoModalContextData {
  const context = React.useContext(WikiChangesNpoModalContext);
  if (context === undefined) {
    throw new Error('useWikiChangesNpoModal must be used within a WikiChangesNpoModalProvider');
  }
  return context;
}

export { WikiChangesNpoModalProvider, useWikiChangesNpoModal };
